module.exports = __webpack_public_path__ + "img/valladolid.4c3e872c.jpg";